module.exports = __webpack_public_path__ + "static/media/img_measurements.5591e490.png";